<template>
  <div class="show-us" ref="activity_scroll" @scroll="activityScroll">
    <div class="menu-main-us">
        <ul class="menu">
            <li @click="handleMenu('1')" :class="menuType == '1'? 'active': ''">品牌视频</li>
            <li v-if="storyDetail" @click="handleMenu('2')" :class="menuType == '2'? 'active': ''">离心机故事</li>
        </ul>
    </div>
    <!-- 视频 -->
    <newProVideo v-show="menuType == '1'" :productVideo="productVideo" @videoChange="videoChange"></newProVideo>
    <footerLine v-show="menuType == '1'"></footerLine>

    <div v-show="menuType == '2'" v-html="storyDetail" class="story-main"></div>
    <!-- 视频播放 -->
    <video-play ref="videoPlay"></video-play>
  </div>
</template>

<script>
import newProVideo from './components/new-pro-video.vue'
import { getProBindList,getProductList } from '@/api/centrifuge'
import DPlayer from 'dplayer'
import { centrifugeRecord } from '@/libs/common'
import videoPlay from '@/components/videoPlay'
import footerLine from '@/components/footerLine'
export default {
    components: {
        newProVideo,
        videoPlay,
        footerLine
    },
    data() {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            page: 1,
            menuType: '1',
            productVideo: [],
            showVideo: false,
            storyDetail: ''
        }
    },
    created() {
        this.getProList()
    },
    methods: {
        handleMenu(type) {
            this.menuType = type
            this.page = 1
            this.productVideo = []
            let para = {
                type: type == '1'? 15 : 16, // 15 品牌视频 16 离心机故事
                uid: this.$store.state.user.id || 0,
                action: 1,
                type_id: 0
            }
            centrifugeRecord(para) // 人数，次数记录
            if (type == '1') {
                this.getProList()
            } else {
                this.getStory()
            }
        },
        getStory() {
            let para = {
                type: 4,
                title: ''
            }
            getProductList(para).then(res => {
                this.storyDetail = res.data.desc
            })
        },
        getProList() {
            let para = {
                module: '5',
                type: '1',
                page: this.page,
                cid: 0
            }
            getProBindList(para).then(res => {
                this.productVideo.push(... res.data.data)
                this.last_page = res.data.last_page
            })
        },
        activityScroll () {
            // console.log('查看');
            var clientHeight = this.$refs.activity_scroll.clientHeight // 该容器的固定高度
            var scrollTop = this.$refs.activity_scroll.scrollTop // 滚动条距顶部的距离
            var scrollHeight = this.$refs.activity_scroll.scrollHeight // 内容的高度
            var inadvance = 5 // 距离底部距离
            this.scrollTop = scrollTop
            if (scrollHeight - scrollTop - inadvance <= clientHeight) {
                if (this.page < this.last_page) {
                    this.page++
                    this.getProList()
                }
            }
        },
        videoChange (item) {
            var videoUrl = JSON.parse(item.video_url)
            this.videoUrl = videoUrl[0]
            this.$refs.videoPlay.dplayerOption(`${this.cdnUrl + this.videoUrl}`)
        },
    }
}
</script>

<style lang="scss" >
.show-us {
    height: 100vh;
    overflow: auto;
}
.menu-main-us {
    display: flex;
    justify-content: center;
    margin: rem(20) 0;
    .menu {
        width: rem(343);
        height: rem(30);
        display: flex;
        justify-content: center;
        // align-items: center;
        border-radius: 4px;
        color: #6CC5DB;
        border: 1px solid #6C94DB;
        li {
            flex: 1;
            line-height: rem(30);
            text-align: center;
        }
        .active {
            color: #fff;
            background-color: #6CC5DB;
            border-radius: 4px;
        }
    }
}
.story-main {
    padding: 0 rem(20);
    img {
        width: 100%;
        height: auto;
    }
}
</style>